import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { memberClosetActions } from 'features/member/closet/reducer';
import {
  selectMemberCloset,
  selectMemberClosetLoading,
} from 'features/member/closet/reducer/memberClosetSelector';
import DataTableLayout from 'components/common/table/datatable/DataTableLayout';

import MemberClosetTableHeader from './memberClosetTableHeader';
import MemberClosetTableBody from './memberClosetTableBody';

interface Props {
  userId: string;
}

const MemberDetailCloset = ({ userId }: Props) => {
  const dispatch = useDispatch();
  const memberCloset = useSelector(selectMemberCloset);
  const isLoading = useSelector(selectMemberClosetLoading);

  useEffect(() => {
    dispatch(memberClosetActions.getMemberCloset({ userId }));
  }, [userId, dispatch]);

  return (
    <DataTableLayout
      tableTitle={`[CLO-SET] Invited Group: Total ${memberCloset.accessibleGroups.length}`}
      showPagination={false}
    >
      <MemberClosetTableHeader totalGroup={memberCloset.accessibleGroups.length} />
      <MemberClosetTableBody memberCloset={memberCloset} isLoading={isLoading} />
    </DataTableLayout>
  );
};

export default MemberDetailCloset;
